import { gql } from 'graphql-tag';

export const projectSettingsFragment = gql`
  fragment ProjectSettings on Project {
    id
    projectTeamMemberAssignmentType
  }
`;
